// services/axiosService.ts
import { LOCAL_STORAGE_KEYS } from '@command-center-app/constants/common.const';
import axios, { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import {env} from '../../env';
const baseURL = `${env.VITE_ALOHA_ADMIN}`;

console.log("base url for axios: ", baseURL);

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
});

// Request interceptor to add Authorization header if token is available
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.JWT_TOKEN);
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Wrapper methods
const get = <T = any>(url: string, config?: AxiosRequestConfig) => axiosInstance.get<T>(url, config);
const post = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) => axiosInstance.post<T>(url, data, config);
const put = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) => axiosInstance.put<T>(url, data, config);
const patch = <T = any>(url: string, data?: any, config?: AxiosRequestConfig) => axiosInstance.patch<T>(url, data, config);
const del = <T = any>(url: string, config?: AxiosRequestConfig) => axiosInstance.delete<T>(url, config);

const axiosService = {
  get,
  post,
  put,
  patch,
  delete: del,
};

export default axiosService;
